let config = {};

export function initConfig(newConfig = {}) {
    config = newConfig;
}

export function get(key) {
    return config[key] ?? null;
}
